export const lowerRatesForEnergyEfficientHomes = {
  heading: 'lower-rates-for-energy-efficient-homes-heading',
  sectionBody: 'lower-rates-for-energy-efficient-homes-sectionBody',
  sectionHeading: 'lower-rates-for-energy-heading',
};
